import { SurchargeDisputeDataSchema } from "@redotech/redo-model/balance/surcharge-dispute";
import * as z from "zod/v4";

export const getSurchargeDisputesAdmin = {
  name: "getSurchargeDisputesAdmin" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z.number(),
    teamId: z.string().optional(),
    search: z.string().optional(),
  }),
  output: z.object({
    disputes: z.array(SurchargeDisputeDataSchema),
    total: z.number(),
  }),
};
